export const ROLE_KEYS = {
  SU: "su",
  ADMIN: "admin",
  PM: "pm",
  PA: "pa",
  FINANCE: "finance",
  SALES: "sales",
  GUEST: "guest"
};

export const ROLE_GROUPS = {
  ADMIN: [ROLE_KEYS.SU, ROLE_KEYS.ADMIN],
  PM_PA: [ROLE_KEYS.PM, ROLE_KEYS.PA],
  ADMIN_PM: [ROLE_KEYS.SU, ROLE_KEYS.ADMIN, ROLE_KEYS.PM],
  ADMIN_FINANCE: [ROLE_KEYS.SU, ROLE_KEYS.ADMIN, ROLE_KEYS.FINANCE],
  ADMIN_PM_PA: [ROLE_KEYS.SU, ROLE_KEYS.ADMIN, ROLE_KEYS.PM, ROLE_KEYS.PA]
};

const joinRoleKeys = (roles) => roles.join(",");

export const ACCOUNT_ROLE_QUERY = Object.freeze({
  SALES_MEMBERS: joinRoleKeys([ROLE_KEYS.SALES, ROLE_KEYS.ADMIN, ROLE_KEYS.SU]),
  PROJECT_MEMBERS: joinRoleKeys([ROLE_KEYS.PM, ROLE_KEYS.PA, ROLE_KEYS.ADMIN, ROLE_KEYS.SU]),
  PM_MEMBERS: joinRoleKeys([ROLE_KEYS.PM, ROLE_KEYS.ADMIN, ROLE_KEYS.SU]),
  PROJECT_USER_CANDIDATES: joinRoleKeys([
    ROLE_KEYS.PM,
    ROLE_KEYS.PA,
    ROLE_KEYS.ADMIN,
    ROLE_KEYS.SALES
  ])
});

export const ROLE_OPTIONS = [
  { title: "超级管理员", value: ROLE_KEYS.SU },
  { title: "管理员", value: ROLE_KEYS.ADMIN },
  { title: "项目经理", value: ROLE_KEYS.PM },
  { title: "项目助理", value: ROLE_KEYS.PA },
  { title: "财务", value: ROLE_KEYS.FINANCE },
  { title: "销售", value: ROLE_KEYS.SALES },
  { title: "客户", value: ROLE_KEYS.GUEST }
];

export function getRoleNames(roles = []) {
  return (roles || []).map((item) => item.name).filter(Boolean);
}

export function hasRole(roles = [], role) {
  const names = getRoleNames(roles);
  if (Array.isArray(role)) {
    return role.some((item) => names.includes(item));
  }
  return names.includes(role);
}
